import { render, staticRenderFns } from "./employee-add.vue?vue&type=template&id=96b2e96e&"
import script from "./employee-add.vue?vue&type=script&lang=js&"
export * from "./employee-add.vue?vue&type=script&lang=js&"
import style0 from "./employee-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports